import { ChangeDetectionStrategy, Component, LOCALE_ID, computed, inject, input, model, output } from '@angular/core';

import { FilterItemSearch } from '../../../../../shared/ui/shared-filters/filter-item-search/filter-item-search';
import { FilterDateComponent } from '../../../../../shared/ui/shared-filters/filter-date-component/filter-date-component';
import { FilterSortingComponent } from '../../../../../shared/ui/shared-filters/filter-sorting-component/filter-sorting-component';

@Component({
  selector: 'app-pharmacy-segment-filter',
  standalone: true,
  imports: [FilterItemSearch, FilterDateComponent, FilterSortingComponent],
  templateUrl: './pharmacy-segment-filter.html',
    styleUrl: './pharmacy-segment-filter.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PharmacySegmentFilter {
  private locale = inject(LOCALE_ID);

  titleFilter = model('');
  paymentTermFilter = model('');
  createdOnFrom = model('');
  createdOnTo = model('');
  modifiedOnFrom = model('');
  modifiedOnTo = model('');
  orderBy = model('EXTRA_DISCOUNT');

  orderDir = input<'ASC' | 'DESC'>('ASC');

  // Outputs
  toggleOrder = output<void>();
  apply = output<void>();
  reset = output<void>();

  private isArabic = computed(() => typeof this.locale === 'string' && this.locale.startsWith('ar'));

  // Labels
  searchLabel = computed(() => (this.isArabic() ? 'اسم الشريحة' : 'Segment Title'));
  searchPlaceholder = computed(() =>
    this.isArabic() ? 'ابحث عن اسم الشريحة...' : 'Search segment title...'
  );
  paymentTermLabel = computed(() => (this.isArabic() ? 'مدة السداد' : 'Payment Term'));
  paymentTermPlaceholder = computed(() => (this.isArabic() ? 'ادخل مدة السداد' : 'Enter payment term'));
  createdOnFromLabel = computed(() => (this.isArabic() ? 'تاريخ الإنشاء من' : 'Created On From'));
  createdOnToLabel = computed(() => (this.isArabic() ? 'تاريخ الإنشاء إلى' : 'Created On To'));
  modifiedOnFromLabel = computed(() => (this.isArabic() ? 'آخر تعديل من' : 'Last Modified From'));
  modifiedOnToLabel = computed(() => (this.isArabic() ? 'آخر تعديل إلى' : 'Last Modified To'));

  //  Date Range Validation
  isCreatedDateRangeInvalid = computed(() => {
    const from = this.createdOnFrom();
    const to = this.createdOnTo();
    if (!from || !to) return false;
    return new Date(from) > new Date(to);
  });

  isModifiedDateRangeInvalid = computed(() => {
    const from = this.modifiedOnFrom();
    const to = this.modifiedOnTo();
    if (!from || !to) return false;
    return new Date(from) > new Date(to);
  });

  //  Sort Options 
  sortOptions = computed(() => [
    { value: 'TITLE', labelEn: 'Title', labelAr: 'اسم الشريحة' },
    { value: 'PAYMENT_TERM', labelEn: 'Payment Term', labelAr: 'مدة السداد' },
    { value: 'EXTRA_DISCOUNT', labelEn: 'Extra Discount', labelAr: 'الخصم الإضافي' },
    { value: 'CREATION_DATE', labelEn: 'Created Date', labelAr: 'تاريخ الإنشاء' },
    { value: 'LAST_MODIFICATION_DATE', labelEn: 'Last Modified On', labelAr: 'آخر تعديل' },
  ]);

  // Actions 
  onApply(): void {
    if (this.isCreatedDateRangeInvalid() || this.isModifiedDateRangeInvalid()) return;
    this.apply.emit();
  }
}